export default "__VITE_ASSET__d746f680__"